// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"dc5b3293","960":"74cd9702"}[chunkId] + ".chunk.css";
};